import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as EditIcon } from '@assets/icons/edit.svg';

import { toastSuccess } from '@components/Toast';

import { checkAnyUserType, getShortName, getUserInfo } from '@utils/Util';

import { BASE_FRONT_END_URL } from '@/constants/constant';

const BlockItem = ({
	block,
	index,
	selectedProducts = [],
	setSelectedProducts,
	onClickBlockImage,
	// onUnlikeProduct,
	// onLikeProduct,
	onMarkProduct,
	setUnmarkProductId,
	setOpenConfirmation
}) => {
	const navigate = useNavigate();

	const handleChange = (e) => {
		let idList = [...selectedProducts];
		let { checked } = e.target;

		if (checked) {
			idList.push(block.id);
		} else {
			idList = idList.filter((item) => item !== block.id);
		}

		setSelectedProducts(idList);
	};

	const onClickCollection = (e, item) => {
		e.stopPropagation();
		navigate(`/collections/view/${item?.collectionId}?requestFrom=blockLibrary`);
	};

	return (
		<>
			<div className="design-single-item" key={`design_item_${index}`}>
				<div
					className={
						selectedProducts.length > 0
							? 'single-design-card with-editable hovered'
							: `single-design-card with-editable ${block?.liked ? 'favorited' : ''}`
					}
				>
					<div className="card-top">
						<div className="edit-items">
							<div className="select-and-edit d-flex justify-content-between">
								<div className="custom-chekbox">
									<div className="form-group d-flex">
										<input
											type="checkbox"
											id={`design_item_${block.id}`}
											value={block.id}
											checked={selectedProducts.includes(block.id)}
											onChange={handleChange}
										/>
										<label htmlFor={`design_item_${block.id}`} />

										{/* <img
											src={
												block?.liked
													? `${process.env.PUBLIC_URL}/icons/favorite.svg`
													: `${process.env.PUBLIC_URL}/icons/not-favorite.svg`
											}
											alt={block?.liked ? 'favourite' : 'not-favourite'}
											className="add-to-favorite"
											onClick={() => {
												block?.liked
													? onUnlikeProduct(block.id)
													: onLikeProduct(block.id);
											}}
										/> */}
									</div>
								</div>

								<div className="d-flex justify-content-between">
									<div>
										<Tooltip title="Edit" placement="top" arrow>
											<span
												data-dismiss="modal"
												onClick={(e) => {
													e.stopPropagation();

													window.open(`/designs/edit/${block.id}`, '_blank');
												}}
												className="edit-design-icon"
											>
												<EditIcon />
											</span>
										</Tooltip>
									</div>
									<div className="option create-option-dropdow">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle"
												type="button"
												id="menu1"
												data-toggle="dropdown"
												aria-expanded="false"
												// onClick={(e) => e.stopPropagation()}
											>
												<img
													src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
													alt="more"
												/>
											</button>
											<ul
												className="dropdown-menu dropdown-menu-right scroll-y-label shadow-lg"
												role="menu"
												aria-labelledby="menu1"
												x-placement="bottom-end"
											>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<span
														role="menuitem"
														tabIndex="-1"
														className="font-weight-normal  text-black"
														onClick={() => {
															navigator.clipboard.writeText(
																`${BASE_FRONT_END_URL}/collections/list?openDesign=true&productId=${block.id}`
															);
															toastSuccess('Copied');
														}}
													>
														Copy block link
													</span>
												</li>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<span
														role="menuitem"
														tabIndex="-1"
														className="font-weight-normal  text-black"
														onClick={() => {
															navigator.clipboard.writeText(
																block?.referenceNumber
															);
															toastSuccess('Copied');
														}}
													>
														Copy block number
													</span>
												</li>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<span
														role="menuitem"
														tabIndex="-1"
														className="font-weight-normal  text-black"
														onClick={() => onClickBlockImage(block.id, true)}
													>
														Edit basic info
													</span>
												</li>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<span
														role="menuitem"
														tabIndex="-1"
														className="font-weight-normal  text-black"
														onClick={() => {
															onMarkProduct(
																block.id,
																'edit',
																block?.parentCatergory
															);
														}}
													>
														Edit block info
													</span>
												</li>
												{(getUserInfo()?.id === block?.blockCreatedBy?.id ||
													checkAnyUserType(['ADMIN', 'GARMENTS_TECH'])) && (
													<li role="presentation" className="px-4 pb-3 pt-3">
														<span
															role="menuitem"
															tabIndex="-1"
															className="font-weight-normal  text-black"
															onClick={() => {
																setUnmarkProductId(block.id);
																setOpenConfirmation(true);
															}}
														>
															Unmark as block
														</span>
													</li>
												)}
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
						<span
							data-toggle="modal"
							data-target="#designViewModal"
							onClick={() => onClickBlockImage(block.id)}
						>
							{block?.designDocuments?.length > 0 ? (
								block?.designDocuments.map((doc, i) => {
									return (
										<img
											key={i}
											src={doc?.docUrl}
											className="card-image"
											alt="product-image"
										/>
									);
								})
							) : (
								<img
									src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
									className="card-image"
									alt="product-image"
								/>
							)}
						</span>
					</div>
					<div
						className="card-content"
						data-toggle="modal"
						data-target="#designViewModal"
						onClick={() => onClickBlockImage(block.id)}
					>
						<div className="card-info">
							<div className="block-status d-flex gap-2 mb-2">
								{block?.blockDetailsResponse?.isNew && (
									<span className="status cyan-4">New</span>
								)}
								{block?.blockDetailsResponse?.isApprovedByBrand && (
									<span className="status green-1">
										Approved by: {block?.blockDetailsResponse?.inspirationBrand?.name}
									</span>
								)}
							</div>
							<div className="">
								<h3 className="title-number semibold-12 mb-1">{block?.referenceNumber}</h3>
								<h4 className="title-number semibold-12">
									{block?.blockDetailsResponse?.blockTitle}
								</h4>
							</div>

							<div className="block-details-item-list">
								{(block?.productGroup || block?.subCategory) && (
									<ul className="common-list-component mt-1">
										{block?.productGroup && (
											<li className="text-uppercase">
												<Tooltip title={block?.productGroup} placement="top" arrow>
													<span className="regular-12 gray_dark_02">
														{getShortName(block?.productGroup, 17)}
													</span>
												</Tooltip>
											</li>
										)}
										{block?.subCategory && (
											<li className="text-uppercase">
												<Tooltip
													title={
														<span className="regular-14">
															{block?.subCategory}
														</span>
													}
													placement="top"
													arrow
												>
													<span className="regular-12 gray_dark_02">
														{getShortName(block?.subCategory, 10)}
													</span>
												</Tooltip>
											</li>
										)}
									</ul>
								)}

								{(block?.blockDetailsResponse?.riseTag ||
									block?.blockDetailsResponse?.lengthTag) && (
									<ul className="common-list-component mt-1">
										{block?.blockDetailsResponse?.riseTag && (
											<li className="text-uppercase">
												<Tooltip
													title={block?.blockDetailsResponse?.riseTag?.text}
													placement="top"
													arrow
												>
													<span className="regular-12 gray_dark_02">
														{getShortName(
															block?.blockDetailsResponse?.riseTag?.text,
															17
														)}
													</span>
												</Tooltip>
											</li>
										)}
										{block?.blockDetailsResponse?.lengthTag && (
											<li className="text-uppercase">
												<Tooltip
													title={block?.blockDetailsResponse?.lengthTag?.text}
													placement="top"
													arrow
												>
													<span className="regular-12 gray_dark_02">
														{getShortName(
															block?.blockDetailsResponse?.lengthTag?.text,
															17
														)}
													</span>
												</Tooltip>
											</li>
										)}
									</ul>
								)}
								{(block?.blockDetailsResponse?.inspirationBrand ||
									block?.blockDetailsResponse?.sizeStandardTag ||
									block?.blockDetailsResponse?.avatarTag) && (
									<ul className="common-list-component mt-1">
										{block?.blockDetailsResponse?.inspirationBrand && (
											<li className="text-uppercase">
												<Tooltip
													title={
														block?.blockDetailsResponse?.inspirationBrand?.name
													}
													placement="top"
													arrow
												>
													<span className="regular-12 gray_dark_02">
														{getShortName(
															block?.blockDetailsResponse?.inspirationBrand
																?.name,
															17
														)}
													</span>
												</Tooltip>
											</li>
										)}
										{block?.blockDetailsResponse?.sizeStandardTag && (
											<li className="text-uppercase">
												<Tooltip
													title={block?.blockDetailsResponse?.sizeStandardTag?.text}
													placement="top"
													arrow
												>
													<span className="regular-12 gray_dark_02">
														{getShortName(
															block?.blockDetailsResponse?.sizeStandardTag
																?.text,
															17
														)}
													</span>
												</Tooltip>
											</li>
										)}
										{block?.blockDetailsResponse?.avatarTag && (
											<li className="text-uppercase">
												<Tooltip
													title={block?.blockDetailsResponse?.avatarTag?.text}
													placement="top"
													arrow
												>
													<span className="regular-12 gray_dark_02">
														{getShortName(
															block?.blockDetailsResponse?.avatarTag?.text,
															17
														)}
													</span>
												</Tooltip>
											</li>
										)}
									</ul>
								)}
								{(block?.blockCreatedBy || block?.collectionName) && (
									<ul className="common-list-component mt-1">
										{block?.blockCreatedBy && (
											<li className="text-uppercase">
												<Tooltip
													title={block?.blockCreatedBy?.name}
													placement="top"
													arrow
												>
													<span className="regular-12 gray_dark_02">
														{getShortName(block?.blockCreatedBy?.name, 17)}
													</span>
												</Tooltip>
											</li>
										)}
										<li>
											<p
												className="collection-name regular-12 gray_dark_01 text-underline pt-0"
												onClick={(e) => onClickCollection(e, block)}
											>
												{block?.collectionName}
											</p>
										</li>
									</ul>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default BlockItem;
